<template>
  <div class="content">
    <div class="container">
      <div class="row m-3 mb-0 mt-0">
        <legend class="mt-2 mb-2">Agregar aclaración a la declaración</legend>
      </div>
      <v-dialog
                v-model="dialog"
                max-width="400">
        <v-card flat class="mx-auto mt-0">
          <v-card-text class="pb-0">
            <v-card-title>Seleccione un archivo</v-card-title>
          </v-card-text>
          <v-form v-model="validation" ref="fileForm" class="pl-3 pr-3 ">
            <v-card-text class="text-center pt-0" style="gap: 1.5rem; display: grid;">
              <!--  accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps" -->
              <v-file-input
                            ref="doc_file"
                            v-model="doc_file"
                            accept="application/pdf"
                            placeholder="Seleccione un archivo"
                            label=""
                            single-line
                            show-size
                            :rules="file_rules"
                            hint="El archivo debe pesar menos de 10MB (Solo formato PDF)."
                            persistent-hint>
              </v-file-input>

              <v-tooltip top color="primary">
                <template v-slot:activator="{ on, value }">
                  <v-btn
                         color="light-green darken-1"
                         class="ml-2  white--text"
                         depressed
                         v-on="on"
                         @click.prevent="uploadFile">
                    Agregar
                  </v-btn>
                </template>
                <span>Subir documento</span>
              </v-tooltip>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <div>

        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-data-table dense :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.documento="{ item }">
                <div class="d-flex justify-content-center m-1">
                  <v-btn color="primary" outlined x-small fab @click.prevent="descargaAclaracion(item.file)" :disabled="item.file == null">
                    <i class="far fa-file-pdf"></i>
                  </v-btn>
                  <br>
                </div>
              </template>
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center m-1" >
                  <v-tooltip top color="primary" :key="'aclaracion1' + item.aclaracion_id" v-if="item.file == null">
                    <template v-slot:activator="{ on }">
                      <v-btn color="success" outlined x-small fab @click.prevent="openDilog(item)" v-on="on" >
                        <i class="fas fa-cloud-upload-alt"></i>
                      </v-btn>
                    </template>
                    <span>Subir archivo</span>
                  </v-tooltip>
                  <!-- <v-tooltip top color="primary" :key="'aclaracion'+ item.aclaracion_id" v-else>
                    <template v-slot:activator="{ on }">
                      <v-btn color="red" outlined x-small fab @click.prevent="removeItem(item)" v-on="on"   >
                        <i class="fas fa-trash"></i>
                      </v-btn>
                    </template>
                    <span>Eliminar archivo</span>
                  </v-tooltip> -->
                </div>
              </template>
              <template v-slot:item.anio="{ item }">
                <div>Declaración {{ filterAnio(item.created_at) }}</div>
              </template>
              <template v-slot:item.file="{ item }">
                <div>{{ dateFormat(item.created_at, true) }}</div>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  FormWizard,
  TabContent
} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import moment from 'moment'
import swal from 'sweetalert2'
export default {
  data () {
    return {
      doc_file: null,
      validation: true,
      dialog: false,
      ip_id: null,
      el_archivo: '',
      wizardModel: {},
      fiscal: [],
      obligado: '',
      xlsx: 0,
      status_dec: 0,
      currentYear: '',
      add_item: false,
      edit_item: false,
      search: '',
      form_item: {},
      table_list: [],
      file_rules: [
        v => !!v || 'El campo es requerido',
        file => !file || !(file.size > (10 * 1024 * 1024)) || 'El archivo debe pesar menos de 10MB.'
      ],
      headers: [{
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      }, {
        text: 'Documentos',
        align: 'center',
        sortable: false,
        value: 'documento',
        width: '200px'

      },
      {
        text: 'Año',
        value: 'anio',
        align: 'center',
        class: '',
        width: '200px'
      },
      {
        text: 'Fecha y hora',
        value: 'file',
        align: 'center',
        class: ''
      }
      ]
    }
  },
  components: {
    FormWizard
  },
  computed: {
    fileExist () {
      let obj = this.table_list.find(o => moment(o.created_at, 'YYYY-MM-DD').format('YYYY') === this.currentYear)
      if (obj) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    '$route': 'checkP',
    dialog (val) {
      if (!val) {
        this.form_item = {}
      }
    }
  },
  methods: {
    enabledelete (item) {
      return moment(item.created_at, 'YYYY-MM-DD').format('YYYY') === this.currentYear
    },
    dateFormat: function (date, time = false) {
      if (date) {
        if (time) {
          return moment(date).format('DD/MM/YYYY HH:mm:ss')
        } else {
          return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
        }
      }
    },
    descargaAclaracion (file) {
      const token = this.$jwt.getToken()
      const auth = 'Bearer ' + (token ? token.hash : '')

      // var url = [this.$http.options.root + 'declaraciones_aclaraciones/' + file];
      var url = ['https:' + this.$rootUrl + '/declaraciones_aclaraciones/' + file]

      window.open(url, '_blank')
    },
    hideButtons (date) {
      return moment(date, 'YYYY-MM-DD').format('YYYY')
    },
    showItem () {
      this.add_item = true
      this.$validator.resume()
    },
    cancelEdit () {
      this.add_item = false
      this.edit_item = false
      this.form_item = {}
      this.$validator.pause()
    },
    addItem () {
      this.$validator.validateAll().then(response => {
        if (response) {
          const formData = new FormData()
          formData.append('upload_file', this.xlsx)
          // this.Ask("Esta apunto de subir el Acuse de la presentación de su declaración fiscal, si NO es el archivo correcto, después de subirlo deberá solicitar permiso para cualquier tipo de cambio ¿desea continuar?", () => {
          this.$http.post('aclaracion', formData).then(
            response => {
              this.StepOk('Guardado')
              if (!this.edit_item) {
                this.table_list.unshift({
                  ...response.data.response
                })
              } else {
                let index = this.table_list.map(u => {
                  return u.id
                }).indexOf(response.data.response.id)
                this.table_list.splice(index, 1, response.data.response)
              }
              this.cancelEdit()
            },
            error => {
              this.Err(error)
            }
          )
          // });
        }
      })
    },
    openDilog (item) {
      this.doc_file = null
      this.dialog = true
      this.form_item = item
      if (this.$refs.fileForm) {
        this.$refs.fileForm.resetValidation()
      }
    },
    closeDilog () {
      this.doc_file = null
      this.dialog = false
      this.form_item = {}
      if (this.$refs.fileForm) {
        this.$refs.fileForm.resetValidation()
      }
    },
    uploadFile () {
      this.$refs.fileForm.validate()
      if (this.validation) {
        // console.log(this.form_item.declaracion_id)
        let obj = { declaracion_id: this.form_item.declaracion_id }

        const formData = this.getFormData(obj)
        formData.append('upload_file', this.doc_file)
        this.$http.post('aclaracion', formData).then(
          response => {
            this.StepOk('Guardado')
            this.getBitacora()
            this.closeDilog()
          },
          error => {
            this.Err(error)
          })
      }
    },
    removeItem (item) {
      if (item.aclaracion_id !== null) {
        this.Ask('Desea borrar este registro', () => {
          this.$http.delete('aclaracion/' + item.aclaracion_id).then(response => {
            // let index = this.table_list.map(u => {
            //   return u.id
            // }).indexOf(item.id)
            // this.table_list.splice(index, 1)
            this.getBitacora()
            this.StepOk('Registro eliminado')
          }, error => {
            this.Err(error)
          })
        })
      }
    },
    checkP () {
      // && this.getKey('status_dec') == 1
      /* if (!(this.getKey('role') == 0 && this.getKey('grupo') != 3)) {
        localStorage.clear();
        this.$router.push('/login');
        this.$router.go();
      } */
    },

    addFile (tipo) {
      this.xlsx = this.$refs.xlsx.files[0]
    },
    siguente () {
      this.$router.push('observaciones')
    },
    getBitacora () {
      this.$http.get('bitacoraDeclaracion/' + this.ip_id).then(
        response => {
          this.table_list = response.data.response
        },
        error => {
          this.Err(error)
        }
      )
    }
    /* validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    validateSecondStep() {
      return this.$refs.secondStep.validate();
    }, */

    /* wizardComplete() {
      // we gather models from all steps into one model
      this.wizardModel = {
        ...this.$refs.datosPersonales.model,
        ...this.$refs.firstStep.model,
        ...this.$refs.DatosCurriculares.model,
        ...this.$refs.DatosConyuge.model,
        ...this.$refs.secondStep.model
      };
      this.$swal("Good job!", "You clicked the finish button!", "success");
    } */
  },
  created () {
    this.currentYear = moment().format('YYYY')

    this.checkP()
    this.ip_id = this.getId()
    this.status_dec = this.getKey('status_dec')

    this.getBitacora()
    // this.$http.get('bitacoraDeclaracion/' + this.ip_id).then(
    //   response => {
    //     this.table_list = response.data.response
    //   },
    //   error => {
    //     this.Err(error)
    //   }
    // )

    // this.$http.get('aclaracion/' + this.ip_id).then(
    //   response => {
    //     this.table_list = response.data.files
    //   },
    //   error => {
    //     this.Err(error)
    //   }
    // )
  },
  mounted () {
    // this.checkCatalogs();
  }
}

</script>
<style>
.vue-form-wizard .wizard-icon-circle.tab_shape {
  background-color: #9a9a9a !important;
  color: white;
}


.custom-file-label::after {
  content: "Buscar" !important;

}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Aclaraciones/Aclaraciones.vue